import React from 'react'
import { Text } from '../Typography'

export default () => {
  return (
    <>
      <Text color='core.nearblack'>How do I see my transaction history?</Text>
      <Text color='core.darkgray'>
        If you&rsquo;re seeing this, you haven&rsquo;t sent or received any FIL
        from this account yet. When you do, your transactions will appear.
      </Text>
    </>
  )
}
